// Auth API calls for the rights workspace. All requests send the session cookie
// (credentials: 'include'); the server reads identity from it.
import apiConfig from '../../../config/api';

const BASE = apiConfig.apiBaseUrl || '';
const JSON_HEADERS = { 'Content-Type': 'application/json' };

export async function apiMe() {
  const res = await fetch(`${BASE}/api/auth?action=me`, { credentials: 'include' });
  if (!res.ok) return null;
  const data = await res.json().catch(() => ({}));
  return data.user || null;
}

async function post(action, body) {
  const res = await fetch(`${BASE}/api/auth?action=${action}`, {
    method: 'POST',
    credentials: 'include',
    headers: JSON_HEADERS,
    body: JSON.stringify(body || {}),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'הפעולה נכשלה. נסו שוב.');
  return data;
}

export async function apiLogin(email, password) {
  return (await post('login', { email, password })).user;
}

export async function apiRegister(email, password, name) {
  return (await post('register', { email, password, name })).user;
}

export async function apiLogout() {
  await fetch(`${BASE}/api/auth?action=logout`, { method: 'POST', credentials: 'include' }).catch(() => {});
}

export async function apiUpdateProfile(fields) {
  return (await post('profile', fields)).user;
}
